
import { Options, Vue } from "vue-class-component";
import PrinterService from "../../service/PrinterService.js";
import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";

@Options({
  title: 'Printer Setups',
  components: {},
})
export default class PrinterSetups extends Vue {
  private lists = [];
  private dialogTitle;
  private keyword = "";
  private toast;
  private goToFirstLink = 0;
  private currentStoreID = 0;
  private printerService;
  private productDialog = false;
  private submitted = false;
  private statusDialog = false;
  private checkPagination = true;
  private totalRecords = 0;
  private limit = 0;
  private home = { icon: "pi pi-home", to: "/" };
  private storeList = [];
  private items = [
    { label: "Initialization", to: "/home/initialization" },
    { label: "Printers", to: "printer-setup" },
  ];

  private printerTypes = [{ key: "Regular" }];

  private defaultTypes = [{ key: "Yes" }, { key: "No" }];

  private selectedStore = {
    id: 0,
  };

  private item = {
    id: 0,
    status: "Active",
  };

  private state = reactive({
    printerName: "",
    printerType: { key: "Regular" },
    defaultPrinter: { key: "No" },
  });

  private validationRules = {
    printerName: {
      required,
    },
    printerType: {
      required,
    },
    defaultPrinter: {
      required,
    },
  };

  private v$ = useVuelidate(this.validationRules, this.state);

  //CALLING WHEN PAGINATION BUTTON CLICKS
  onPage(event) {
    this.loadList(event.first);
  }

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.printerService = new PrinterService();
    this.toast = new Toaster();
  }

  //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.loadList(0);
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {
    this.clearItem();

    this.submitted = false;
    this.dialogTitle = "Add New Printer";
    this.productDialog = true;
  }

  //CLOSE THE ITEM DAILOG BOX
  hideDialog() {
    this.productDialog = false;
    this.submitted = false;
  }

  //ADD OR UPDATE THE ITEM VIA HTTP
  saveItem(isFormValid) {
    this.submitted = true;
    if (isFormValid) {
      if (this.item.id != 0) {
        this.printerService.updateItem(this.item, this.state).then((res) => {
          this.loadList(this.goToFirstLink);
          //SHOW NOTIFICATION
          this.toast.handleResponse(res);
        });
      } else {
        this.printerService
          .saveItem(this.item, this.state, this.currentStoreID)
          .then((res) => {
            this.goToFirstLink = 0;
            this.loadList(this.goToFirstLink);
            //SHOW NOTIFICATION
            this.toast.handleResponse(res);
          });
      }

      this.productDialog = false;
      this.clearItem();
    }
  }

  //OPEN DIALOG BOX TO EDIT
  editIem(data) {
    this.submitted = false;
    this.dialogTitle = "Update Printer";
    this.productDialog = true;

    this.printerService.getItem(data).then((res) => {
      if (res.length > 0) {
        this.state.printerName = res[0].printer_name;
        this.state.printerType.key = res[0].printer_type;
        this.state.defaultPrinter.key = res[0].default_printer;
        this.item.status = res[0].status;
        this.item.id = res[0].id;
      }
    });
  }

  //OPEN DIALOG BOX FOR CONFIRMATION
  confirmChangeStatus(data) {
    this.item.id = data.id;
    this.state.printerName = data.printer_name;
    this.statusDialog = true;
  }

  //CHANGE THE STATUS AND SEND HTTP TO SERVER
  changeStatus() {
    this.statusDialog = false;
    this.item.status = "Delete";
    this.printerService.changeStatus(this.item).then((res) => {
      this.loadList(0);
      //SHOW NOTIFICATION
      this.toast.handleResponse(res);
    });
  }

  //FETCH THE DATA FROM SERVER
  loadList(page) {
    this.printerService
      .getItems(this.selectedStore.id, this.keyword, page)
      .then((data) => {
        this.lists = data.records;
        this.totalRecords = data.totalRecords;
        this.storeList = data.stores;
        this.limit = data.limit;
        this.currentStoreID = data.currentStoreID;
      });
  }

  clearItem() {
    this.item = {
      id: 0,
      status: "Active",
    };

    this.state.printerName = "";
    this.state.printerType.key = "Regular";
    this.state.defaultPrinter.key = "No";
  }
}
